import p1 from '../../assest/Project/Burger.png';
import p2 from '../../assest/Project/RGB.png';
import p3 from '../../assest/Project/Pat.png';
import p4 from '../../assest/Project/yell.png';
import p5 from '../../assest/Project/cpp.png';
import p6 from '../../assest/Project/todo.png';



const data = [
    {
        name:"BurgerBuilder",
        url:"https://burgerbuilder-17a5b.web.app/",
        github:"https://github.com/AStream26/BurgerBuilder",
        image:p1,
        type:['react.js']

    },
    {
        name:"Blog App",
        url:"##",
        github:"https://github.com/AStream26/Blogapp",
        image:p4,
        type:['node.js','mongodb']

    }, {
        name:"Color Game",
        url:"https://astream26.github.io/Colorgame/",
        github:"https://github.com/AStream26/Colorgame",
        image:p2,
        type:['vanillajs']

    }, {
        name:"Patratap",
        url:"https://astream26.github.io/Patratap/",
        github:"https://github.com/AStream26/Patratap",
        image:p3,
        type:['Jquery']

    }, {
        name:"Cab Locator",
        url:"##",
        github:"https://github.com/AStream26/c-project",
        image:p5,
        type:['C++']

    }, {
        name:"BurgerBuilder",
        url:"https://burgerbuilder-17a5b.web.app/",
        github:"https://github.com/AStream26/BurgerBuilder",
        image:p1,
        type:['Bootstrap']

    }, {
        name:"TO DO List",
        url:"https://astream26.github.io/TODO-LIST/",
        github:"https://github.com/AStream26/TODO-LIST",
        image:p6,
        type:['vanillajs']

    }
]

export default data;